<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="top_input">
				<el-input v-model="searchWord" placeholder="请输入"></el-input>
			</div>
			<div class="search_btn" @click="getData">查询</div>
			<div v-if="permissionItem.add" class="add_btn" @click="add">添加</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<el-table-column prop="cocId" label="客商编号" width="140"></el-table-column>
					<el-table-column prop="cocName" label="客商名称" width="220"></el-table-column>
					<el-table-column prop="cocType" label="客商类型" width="100">
						<template #default="scope">
							<span v-if="scope.row.cocType == '0'">承运商</span>
							<span v-else-if="scope.row.cocType == '1'">托运商</span>
							<span v-else-if="scope.row.cocType == '2'">货源商</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="cocUserId" label="客商用户名">
						<template #default="scope">
							<span
								v-if="scope.row.cocUserId !== null && scope.row.cocUserId !== undefined">{{scope.row.userLgname}}</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column label="状态">
						<template #default="scope">
							<el-switch :value="scope.row.cocStatusBoolen" active-text="正常" inactive-text="禁用"
								@change="updateState(scope.row)">
							</el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="cocContact" label="联系人"></el-table-column>
					<el-table-column prop="cocPhone" label="联系电话"></el-table-column>
					<el-table-column prop="cocAddr" label="详细地址">
						<template #default="scope">
							<div class="cell-style">{{ scope.row.cocAddr }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="cocRemark" label="备注"></el-table-column>
					<el-table-column prop="cocCretime" label="创建时间"></el-table-column>
					<el-table-column label="操作">
						<template #default="scope">
							<span v-if="permissionItem.edit" class="default_color pointer m-right10" v-on:click="edit(scope.row.cocId)">编辑</span>
							<span v-if="permissionItem.list" class="default_color pointer m-right10" v-on:click="detail(scope.row.cocId)">详情</span>
							<span v-if="permissionItem.del" class="col-FF1A1A pointer m-right10" v-on:click="del(scope.row.cocId)">删除</span>
							<!-- <span class="default_color pointer" v-on:click="resetMm(scope.row)">重置密码</span> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "customerManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "orgManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				
				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "customerManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "customerManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "customerManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "customerManage:del") {
						data.permissionItem.del = true;
					}
				});
				
				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询客商列表权限！");
					return;
				}
				
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					// roleOrg: store.state.userInfo.orgId,
				};
				const r = await proxy.$http.get(apiObj.cusList, params);
				console.log(r);
				if (r.code === 0) {
					r.rows.forEach((el) => {
						el.cocStatusBoolen = el.cocStatus == 0 ? true : false;
					});
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};

			// 添加 根目录
			const add = () => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有客商添加权限！");
					return;
				}
				
				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有客商编辑权限！");
					return;
				}
				
				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有客商查询权限！");
					return;
				}
				
				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};
			//菜单删除
			const del = (cocId) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有客商删除权限！");
					return;
				}
				
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							cocId: cocId,
						};
						const r = await proxy.$http.postFormData(apiObj.cusDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const updateState = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有客商编辑权限！");
					return;
				}
				
				proxy.$confirm(
					`您确定执行${!row.cocStatusBoolen ? "启用" : "禁用"}操作，是否继续?`,
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					proxy.$http
						.postFormData(
							"/biz/bdzl/coopClient/updateStatus", {
								cocId: row.cocId,
								status: row.cocStatusBoolen ? 1 : 0
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
								getData();
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			const resetMm = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有客商编辑权限！");
					return;
				}
				
				var val = row.cocId;
				proxy.$confirm(
					"您确定将" +
					row.cocName +
					"(" +
					row.userLgname +
					")重置密码为‘123456’吗?",
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(() => {
					proxy.$http
						.postFormData(
							"/biz/bdzl/coopClient/resetPwd", {
								cocId: val
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				updateState,
				resetMm,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.el-switch {
		overflow: visible !important;
		/* 确保文本可以显示 */
	}
	.cell-style {
		white-space: nowrap;
		/* 防止内容换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略符号来代表被修剪的文本 */
	}
</style>